import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 mt-8 gap-5 items-start" }
const _hoisted_2 = { class: "col-span-12 md:col-span-4 flex justify-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-span-12 md:col-span-8 flex flex-col gap-5" }
const _hoisted_5 = { class: "w-[100%] flex flex-row justify-center items-center space-x-6" }
const _hoisted_6 = { class: "w-[80%]" }
const _hoisted_7 = { class: "text-base w-100" }
const _hoisted_8 = { class: "flex flex-row flex-wrap justify-center sm:justify-end gap-4 mt-8" }
const _hoisted_9 = { class: "w-full flex justify-center items-center mt-8 space-x-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_RecordStream = _resolveComponent("RecordStream")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.skipModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.skipModal) = $event)),
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '35vw', minWidth: '360px' },
      modal: true,
      showHeader: false,
      contentStyle: "background-color: #F2F8FF",
      class: "dialog"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: require('@/assets/images/avatares/repproved.gif'),
              class: "md:w-full w-1/2 rounded-full",
              alt: "repproved img",
              loading: "lazy"
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t("skipModal.title")), 1),
              _createElementVNode("div", null, [
                _createVNode(_component_MessageVoice, {
                  msg: _ctx.$t('skipModal.subtitle'),
                  onOnEndMessage: _ctx.permissToListen,
                  showIconsName: false,
                  scaleIcons: 0.8
                }, null, 8, ["msg", "onOnEndMessage", "scaleIcons"])
              ])
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("skipModal.subtitle")), 1)
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createVNode(_component_Button, {
            class: "btn-outline p-button-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.skipVideo(false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("skipModal.finalize")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "btn-primary p-button-sm",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.skipVideo(true)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("skipModal.next")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("section", _hoisted_9, [
          _createVNode(_component_v_icon, {
            name: "md-spatialaudiooff",
            class: "text-primary-400"
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Você também pode responder por voz. Ex: 'Avançar' ou 'Cancelar'",
            en: "You can also reply by voice. Ex: 'Next' or 'Cancel'",
          })), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _withDirectives(_createVNode(_component_RecordStream, {
      ref: "recordStream",
      encodeType: "move_object"
    }, null, 512), [
      [_vShow, _ctx.recording]
    ])
  ], 64))
}